import { RateMyServiceAnswer } from '../interfaces/ratings'
interface IQuestion {
  id: string
  questionText: string
  answerType: string
  isAnswerRequired: boolean
  isEnabled: boolean
  options: {
    optionKey: string
    optionValue: string
  }[]
}

export const getSubmitButtonStatus = (
  requiredQuestions: string[],
  responses: RateMyServiceAnswer[]
): boolean => {
  if (!requiredQuestions || !responses) return false
  const answersMap = new Map(
    responses.map((res) => [res.questionId, res.responses])
  )
  return requiredQuestions.every((req) => {
    const response: any = answersMap.get(req)
    return response && response.length > 0
  })
}

export const getAnswerTypes = (questions: IQuestion[]) => {
  if (!questions) return ''
  const answerTypesArray =
    questions.map((question: IQuestion) => question.answerType) || []
  return answerTypesArray.join(', ')
}

export const getAnswersResponse = (answers: RateMyServiceAnswer[]) => {
  if (!answers) return ''
  const responses: string[] = []
  answers.forEach((answer) => {
    if (Array.isArray(answer.responses)) {
      responses.push(...answer.responses)
    }
  })

  return responses?.join(', ')
}

export const defineEntryMethodAndScreen = () => {
  try {
    const currentPageUrl = new URL(window.location.href).pathname
    const urlMappings = {
      '/history': {
        entry_method: 'ticket_history',
        screen_name: 'Ticket History',
        step_name: 'Ticket History',
      },
      '/home': {
        entry_method: 'home_screen',
        screen_name: 'Home',
        step_name: 'Home',
      },
    }

    for (const [key, value] of Object.entries(urlMappings)) {
      if (currentPageUrl.includes(key)) {
        return value
      }
    }
  } catch (error) {
    return null
  }
  return { entry_method: null, screen_name: null, step_name: null }
}
